import { TagGroupCreateInput } from '@vivport/backend/types';
import { useState } from 'react';
import { Sheet, SheetContent, SheetFooter, SheetHeader, SheetTitle, SheetDescription } from '@/components/ui/sheet';
import { Separator } from '@/components/ui/separator';
import { TagGroupFormValues, Work4MeTagGroupForm } from './Work4MeTagGroupForm';

interface Work4MeTagGroupCreateProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onTagGroupCreated: (input: TagGroupCreateInput) => Promise<void>;
}

const EMPTY_CREATE_VALUES: TagGroupFormValues = {
  name: '',
  description: '',
  scope: 'PRIVATE',
  selectionMode: 'SINGLE',
  groupOrder: undefined,
};

export function Work4MeTagGroupCreate({ open, onOpenChange, onTagGroupCreated }: Work4MeTagGroupCreateProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        className="w-screen sm:w-[540px] flex flex-col px-0 no-close-borders"
        aria-describedby={undefined}
      >
        <SheetHeader className="px-4">
          <SheetTitle>Create New Tag Group</SheetTitle>
          <SheetDescription>
            Add a new tag group to organize your tags. Groups help categorize related tags and can enforce exclusive selection rules.
          </SheetDescription>
        </SheetHeader>

        <div className="flex-1 px-4 py-4 overflow-y-auto">
          <Work4MeTagGroupForm
            initialValues={EMPTY_CREATE_VALUES}
            isSubmitting={isSubmitting}
            submitLabel="Create Group"
            submittingLabel="Creating..."
            onSubmit={async (values) => {
              setIsSubmitting(true);
              try {
                await onTagGroupCreated({
                  name: values.name,
                  description: values.description === '' ? null : values.description,
                  scope: values.scope,
                  selectionMode: values.selectionMode,
                  groupOrder: values.groupOrder,
                });
                onOpenChange(false);
              } finally {
                setIsSubmitting(false);
              }
            }}
          />
        </div>

        <SheetFooter className="px-4">
          <div className="w-full">
            <Separator className="mb-4" />
            <p className="text-xs text-muted-foreground">Fill all required fields to create a tag group.</p>
          </div>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}

